import React, { useEffect, useState } from 'react'
import { KeyValue } from '../../../Common/Components/KeyValue';
import { get } from '../../../../Model/Network/Config/Axios';
import moment from 'moment';
import { Spinner } from '../../../Common/fLoader';

function ReferenceType({referenceType,id,setInvoices,AmountDetails}) {
    const [data,setData] = useState(undefined);
    const [loading,setLoading] = useState(true);

    useEffect(()=>{
        setLoading(true);
        if(referenceType==="INVOICES"|| referenceType==="GST_WITHHELD" || referenceType==="PARTIAL"){
            get(`/vendor/invoicing/${id}/details`,(e,r)=>{
                if(r){
                    setData({
                        "Bill Number":(r && r.invoice && r.invoice.billNumber)?r.invoice.billNumber:"",
                        "Business Name":(r && r.vendor && r.vendor.name)?r.vendor.name:"",
                        "Trade Name":(r && r.vendor && r.vendor.tradeName)?r.vendor.tradeName:"",
                        "Date":(r && r.invoice && r.invoice.date)?r.invoice.date:"",
                        "Invoice Id":(r && r.invoice && r.invoice.counterId)?r.invoice.counterId:"",
                        "Category":(r && r.invoice && r.invoice.category)?r.invoice.category:"",
                        "Service":(r && r.invoice && r.invoice.service)?r.invoice.service:"",
                        "db_invoice_id": r && r.invoice && r.invoice.id
                    })
                    setLoading(false);
                }
                else if(e){
                    setLoading(false);
                }
            })
        }
        else if(referenceType==="PAYMENT_TICKET"){
            get(`/vendor/paymentTicket/getDetails/${id}`,(e,r)=>{
                if(r){
                    setData({
                        "Payment Ticket Id":(r && r.paymentTicketId)?r.paymentTicketId:"",
                        "Created By":(r && r.owner && r.owner.ownerName)?r.owner.ownerName:"",
                        "Created Date":(r && r.createdAt)?moment(r.createdAt).format("DD-MM-YYYY"):"",
                        "Due Date":(r && r.dueDate)?moment(r.dueDate).format("DD-MM-YYYY"):"",
                        "Payable Amount":(r && r.payableCurrencyAmount)?`${r.currency} ${r.payableCurrencyAmount}`:"",
                        "Vendor Trade Name":(r && r.vendor && r.vendor.tradeName)?r.vendor.tradeName:""
                    })
                    setInvoices((r&&r.items)?r.items:[]);
                    setLoading(false);
                }
                else if(e){
                    setLoading(false);
                }
            })
        }
        else{
            get(`vendor/advances/${id}/details`,(e,r)=>{
                if(r){
                    setData({
                        "Advance Id":(r && r.advanceId)?r.advanceId:"",
                        "Owner Name":(r && r.owner && r.owner.ownerName)?r.owner.ownerName:"",
                        "Advance Amount":(r && r.amount)?r.amount:"",
                        "Tds":(r && r.tds && r.tds.tds)?r.tds.tds:"",
                        "Tds Code":(r && r.tds && r.tds.code)?r.tds.code:"",
                        "Remarks":(r && r.remarks)?r.remarks:"",
                        "Vendor Name":(r && r.vendor && r.vendor.name)?r.vendor.name:"",
                        "Office":(r && r.office)?r.office:'-'
                    })
                    setLoading(false);
                }
                else if(e){
                    setLoading(false);
                }
            })
        }
    },[])

    if(referenceType && id && loading){
        return <Spinner/>
    }

    return (
        <div>
            {
                (data && Object.keys(data).length)?<div>
                    <div style={{ fontSize: '14px', fontWeight: 'bold', margin: '20px 0px 15px 0px' }}>{`${referenceType==="INVOICES"?"Invoice Details":referenceType==="PAYMENT_TICKET"?"Payment Ticket Details": referenceType==="PARTIAL"?"Partial Settlement Details":"Vendor Advance Details"}`}</div>
                    {
                        (Object.keys(data).filter((item)=>{return data[item]!==""}).map((item)=>{
                            if(item==="Invoice Id"){
                                return <KeyValue to={`/app/banking/invoice/${data["db_invoice_id"]}`} title={item} value={data[item]} />
                            }
                            else{
                                return <KeyValue title={item} value={data[item]} />
                            }
                        }))
                    }
                </div>:null
            }
            <KeyValue title='Amount' value={`${AmountDetails.currency} ${AmountDetails.amount}`} />
            <KeyValue title='Paid Amount' value={`${AmountDetails.currency} ${AmountDetails.paidAmount}`} />
            <KeyValue title='Reference Type' value={`${AmountDetails.referenceType}`} />
        </div>
    )
}

export default ReferenceType